var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-minus-circle fa-lg icon-button",attrs:{"title":"Remover item"},on:{"click":function($event){$event.stopPropagation();return _vm.removerItem()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }